import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { CustomStepCategoryEnum, FunnelInputTypeEnum, StepBasicLayout, StepElements } from '../../../_models';
import { StepEmulatorService } from '../../../_services';

@Component({
  selector: 'step-layout',
  templateUrl: './step-layout.component.html',
  styleUrls: ['./step-layout.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [animate('300ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class StepLayoutComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() layout: StepBasicLayout;
  @Input() stepType: CustomStepCategoryEnum;

  funnelInputTypeEnum = FunnelInputTypeEnum;
  stepElements = StepElements;

  layoutOptions = [
    { value: FunnelInputTypeEnum.Choice, label: 'Buttons' },
    { value: FunnelInputTypeEnum.Radio, label: 'Radio List' },
    { value: FunnelInputTypeEnum.Select, label: 'Dropdown' },
  ];

  constructor(private stepEmulatorService: StepEmulatorService) {}

  ngOnInit(): void {
    this.updateButtonValidation(this.form.get('type').value);
  }

  toggleElement(element: StepElements): void {
    this.stepEmulatorService.toggleElement(element);
  }

  isElementVisible(element: StepElements): boolean {
    return this.stepEmulatorService.isElementVisible(element);
  }

  isTypeSelected(type: FunnelInputTypeEnum): boolean {
    return this.form.get('type').value === type;
  }

  // For PauseSub and AdjustShippingFrequency, only inputs with an existing response step should have their type updated
  get isPauseSubOrAdjustShipping(): boolean {
    return (
      this.stepType === CustomStepCategoryEnum.PauseSub ||
      this.stepType === CustomStepCategoryEnum.AdjustShippingFrequency
    );
  }

  onTypeClick(type: FunnelInputTypeEnum): void {
    this.form.patchValue({ type });
    const inputs = this.form.get('inputs') as FormArray;

    if (inputs) {
      inputs.controls.forEach((control) => {
        const hasResponseStep = control.get('has_response_step') && control.get('has_response_step').value;

        if (this.isPauseSubOrAdjustShipping) {
          if (hasResponseStep) {
            control.patchValue({ type });
          }
        } else {
          control.patchValue({ type });
        }
      });
    }

    this.updateButtonValidation(type);
  }

  private updateButtonValidation(type: FunnelInputTypeEnum): void {
    const buttonStyles = this.form.get('button_styles');
    if (buttonStyles) {
      const confirmLabel = buttonStyles.get('confirm') && buttonStyles.get('confirm').get('label');
      if (confirmLabel) {
        if (type === FunnelInputTypeEnum.Choice) {
          confirmLabel.clearValidators();
        } else {
          confirmLabel.setValidators(Validators.required);
        }
        confirmLabel.updateValueAndValidity();
      }
    }
  }
}
